module.exports = __webpack_public_path__ + "static/wprarticleimage-596cddec3f52148c3ff1798c33853464.jpeg";